import { ReactNode } from 'react'

import RVLogo from '@/presentation/assets/svg/RVLogo.svg'

interface OnboardingBaseProps {
  showLogo?: boolean
  Body: ReactNode
  Button?: ReactNode
  BackgroundImage?: string
}

const OnboardingBase: React.FC<OnboardingBaseProps> = ({
  showLogo,
  Body,
  Button,
  BackgroundImage
}) => (
  <div className="mt-28 flex size-full flex-col items-center justify-center gap-4 px-4 py-2">
    {showLogo && (
      <div className="mb-10 flex items-center justify-center">
        <img className="block h-full sm:h-28" src={RVLogo} alt="GrupoRV Logo" />
      </div>
    )}

    {Body}

    {Button}

    {BackgroundImage && (
      <>
        <div className="fade-top" />
        <img
          className="absolute left-0 top-0 -z-10 size-full object-cover object-right sm:object-center"
          src={BackgroundImage}
        />
      </>
    )}
  </div>
)

export default OnboardingBase
